<script lang="ts">
  import type { ArtAsset } from '@entities/art-asset';

  import DigitalNativeIcon from './digital-native-icon.svelte';
  import DigitalOriginalIcon from './digital-original-icon.svelte';
  import DOLabel from './label.svelte';
  import Modal from './modal.svelte';

  export let digitalOriginalData: ArtAsset['digital_original'] | null = null;

  export let isShowModal = false;

  $: isDigitalOriginal = !!digitalOriginalData;

  const toggleModal = () => {
    if (isDigitalOriginal) {
      isShowModal = !isShowModal;
    }
  };
</script>

<DOLabel
  on:click="{toggleModal}"
  variant="{isDigitalOriginal ? 'secondary' : 'primary'}"
  hasHover="{isDigitalOriginal}"
>
  {#if isDigitalOriginal}
    <DigitalOriginalIcon />
    Digital Original
  {:else}
    <DigitalNativeIcon />
    Digital Native
  {/if}
</DOLabel>

{#if isDigitalOriginal}
  <Modal bind:isShowModal {digitalOriginalData} />
{/if}
